import { TextField } from "@mui/material";
import { useState } from "react";
import UnorderedList from "../utils/UnorderedList";


function ReviewWritingContent({ item, editContent, onSave }) {
    const [url, setUrl] = useState(item.content.url);
    const [code, setCode] = useState(item.content.code);
    const [review, setReview] = useState(item.content.review);

    const handleUrlChange = (e) => { setUrl(e.target.value); };
    const handleCodeChange = (e) => { setCode(e.target.value); };
    const handleReviewChange = (e) => { setReview(e.target.value); };

    return (
        <div className="review-writing-wrp">
            <div className="requested-topic-wrp">
                <div className="topic-title">Review Writing - </div><div>Your requested Topic for Review writing</div>
            </div>
            <label>Review URL</label>
            <TextField className="rw-url" fullWidth placeholder="Enter Review URL" value={url} InputLabelProps={{ shrink: false }} onChange={handleUrlChange} />
            <label>Review Code</label>
            <TextField className="rw-code" placeholder="Enter Review Code" value={code} InputLabelProps={{ shrink: false }} onChange={handleCodeChange} />
            <UnorderedList title='Write Your Review' compensation={[
                'Repeated & Copied reviews will be deleted.',
                'So, Kindly write the genunie review what you feel about the article you read.']} />
            <TextField id="outlined-multiline-flexible"
                placeholder="Enter Your Review"
                multiline
                value={review}
                rows={10}
                InputLabelProps={{ shrink: false }}
                onChange={handleReviewChange}
            />
            <div className="success-wrp">{editContent.successMsg}</div>
            <div className="save-content-btn-wrp">
                <div className="save-content-btn hbw-button" onClick={() => { }}>Submit</div>
            </div>
        </div>
    );
};
export default ReviewWritingContent;